export type PlatformKind = "desktop" | "web" | "ios" | "android";

export type CapabilitySupport =
  | "available"
  | "degraded"
  | "unavailable";

export interface CapabilityDescriptor {
  readonly support: CapabilitySupport;
  readonly reason?: string;
}

export interface PlatformCapabilities {
  readonly platform: PlatformKind;
  readonly structuredStorage: CapabilityDescriptor;
  readonly attachmentStorage: CapabilityDescriptor;
  readonly files: CapabilityDescriptor;
  readonly camera: CapabilityDescriptor;
  readonly share: CapabilityDescriptor;
  readonly installable: CapabilityDescriptor;
  readonly backgroundSync: CapabilityDescriptor;
  readonly complexCanvasEditing: CapabilityDescriptor;
}

export type PlatformErrorCode =
  | "unsupported"
  | "cancelled"
  | "permission-denied"
  | "not-found"
  | "quota-exceeded"
  | "corrupt-data"
  | "read-only"
  | "operation-failed";

export class PlatformRuntimeError extends Error {
  public constructor(
    public readonly code: PlatformErrorCode,
    message: string,
    public readonly capability: keyof Omit<PlatformCapabilities, "platform">,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = "PlatformRuntimeError";
  }
}

export function unavailableCapability(
  capability: keyof Omit<PlatformCapabilities, "platform">,
  reason: string,
): never {
  throw new PlatformRuntimeError(
    "unsupported",
    reason,
    capability,
  );
}
